import * as React from 'react';

import MuiButton, { ButtonProps as MuiButtonProps } from '@material-ui/core/Button';
import MuiFab, { FabProps as MuiFabProps } from '@material-ui/core/Fab';

export interface IButtonProps extends MuiButtonProps {
  fdKey: string;
}

export interface IFabProps extends MuiFabProps {
  fdKey: string;
}

export type ButtonProps = {
  fdKey: string;
  children: React.ReactChildren;
  variant?: string;
} & MuiButtonProps;

export type FabProps = {
  fdKey: string;
  children: React.ReactChildren;
  variant?: string;
} & MuiFabProps;

export function Button(props: IFabProps): React.ReactElement<typeof MuiFab>;
export function Button(props: IButtonProps): React.ReactElement<typeof MuiButton>;
export function Button({ children, fdKey, variant, ...props }: ButtonProps | FabProps) {
  switch (variant) {
    case 'fab':
      return (
        <MuiFab {...(props as FabProps)} data-fd={fdKey}>
          {children}
        </MuiFab>
      );

    case 'extendedFab':
      return (
        <MuiFab {...(props as FabProps)} data-fd={fdKey} variant="extended">
          {children}
        </MuiFab>
      );

    default:
      return (
        <MuiButton
          {...(props as ButtonProps)}
          data-fd={fdKey}
          variant={variant as ButtonProps['variant']}
        >
          {children}
        </MuiButton>
      );
  }
}

// Button.defaultProps = MiuButton.defaultProps;

export default Button;
